import { useState } from 'react';
import type { AnnotationCategory } from '../../lib/types';

const STYLES: Record<AnnotationCategory, string> = {
  favorable: 'bg-cat-fav-pastel text-cat-fav',
  defavorable: 'bg-cat-def-pastel text-cat-def',
  important: 'bg-cat-imp-pastel text-cat-imp-text',
  a_verifier: 'bg-cat-ver-pastel text-cat-ver',
};

const RING: Record<AnnotationCategory, string> = {
  favorable: 'ring-cat-fav',
  defavorable: 'ring-cat-def',
  important: 'ring-cat-imp',
  a_verifier: 'ring-cat-ver',
};

/**
 * Pastille compteur de catégorie. Drop target pour le drag&drop d'une
 * AnnotationItem (U8) : si ``onDropAnnotation`` est fourni, accepte un
 * MIME ``application/x-adr-annotation-id`` contenant l'UUID de
 * l'annotation et change sa catégorie.
 */
export default function CounterCircle({
  category,
  count,
  title,
  onDropAnnotation,
}: {
  category: AnnotationCategory;
  count: number;
  title?: string;
  onDropAnnotation?: (annotationId: string) => void | Promise<void>;
}) {
  const [over, setOver] = useState(false);

  const handlers = onDropAnnotation
    ? {
        onDragOver: (e: React.DragEvent) => {
          if (e.dataTransfer.types.includes('application/x-adr-annotation-id')) {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';
            if (!over) setOver(true);
          }
        },
        onDragLeave: () => setOver(false),
        onDrop: (e: React.DragEvent) => {
          e.preventDefault();
          setOver(false);
          const id = e.dataTransfer.getData('application/x-adr-annotation-id');
          if (id) void onDropAnnotation(id);
        },
      }
    : {};

  return (
    <span
      {...handlers}
      className={`inline-flex h-[26px] w-[26px] items-center justify-center rounded-full text-[11px] font-semibold ${STYLES[category]} ${
        over ? `ring-2 ring-offset-1 ${RING[category]}` : ''
      } ${onDropAnnotation ? 'transition' : ''}`}
      title={title}
    >
      {count}
    </span>
  );
}
